var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 354.68 71.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e0e17;}.cls-2{fill:#e5e5e5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sad_copy",
    "data-name": "sad copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.29,43.7S239.07-3.6,290.18,2.55c0,0,26.32,4.52,33.21,12.84l1.9,5.31,5.59-1.42s24.18,17.65,23.8,17.54-9.39,6.88-9.39,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.39,41.7S115.61-5.6,64.5.55c0,0-26.31,4.52-33.21,12.84l-1,4.31-6.49-.42S-.38,34.93,0,34.82,9.39,41.7,9.39,41.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M345.29,43.7s-27.76,28-62,28-62-28-62-28,27.76-28,62-28S345.29,43.7,345.29,43.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.66,41.84s-27.76,28-62,28-62-28-62-28,27.75-28,62-28S133.66,41.84,133.66,41.84Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 283.28,
    cy: 43.6,
    r: 28.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.6,
    cy: 41.83,
    r: 28.21
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg40);
export default __webpack_public_path__ + "static/media/40.88675ab1.svg";
export { ForwardRef as ReactComponent };